import { render } from "./RunTests.vue?vue&type=template&id=bb2f4c66"
import script from "./RunTests.vue?vue&type=script&lang=ts"
export * from "./RunTests.vue?vue&type=script&lang=ts"
script.render = render

export default script